import { TextEditor } from './TextEditor';

export function createTextEditor(ref: any, context: any) {
    let textEditor = new TextEditor().createTextEditorByRef(ref, context);
    return {
        // TextEditor has never had a destroy (pre-existing); releasing the
        // IJSObjectReference frees the instance for GC.
        dispose: () => { },

        makeTextBold: () => textEditor?.makeTextBold(),

        makeTextItalic: () => textEditor?.makeTextItalic(),

        makeTextSmall: () => textEditor?.makeTextSmall()
    };
}
